module.exports = __webpack_public_path__ + "img/solicite-01.5cf9c613.png";